import React, { useState, useEffect } from 'react';
import { useDialogsContext } from '../contexts/Dialog';
import {
  getCompany,
  getPlaidLink,
  getBankAccounts,
  getAmazonSellerAccounts,
} from '../components/API';
import { getUserAttributes } from '../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Layout from '../components/SubmitApplication/Stepper';
import Success from '../components/SubmitApplication/Success';
import LoadingBackdrop from '../components/LoadingBackdrop';
import TermOfUseAndPrivacyPolicy from './TermOfUseAndPrivacyPolicy';

const useStyles = makeStyles((theme: any) => ({
  root: { maxWidth: 950, position: 'relative', padding: theme.spacing(3) },
  container: { marginTop: theme.spacing(2) },
}));

export default function SubmitApplication() {
  const classes = useStyles();
  const dialogs: any = useDialogsContext();
  const [loading, setLoading] = useState(false);
  const [hasBank, setHasBank] = useState(null);
  const [plaidLinkToken, setPlaidLinkToken] = useState(null);
  const [business, setBusiness] = useState(null);
  const [lines, setLines] = useState(null);
  const [gotDataFromServer, setGotDataFromServer] = useState(false);
  const [amzAccounts, setAmzAccounts] = useState(null);

  async function getLinesInApplication() {
    const url = new URLSearchParams(window.location.search);
    let lines = url.get('lines');
    lines ? setLines(JSON.parse(lines)) : setLines([]);
  }

  async function getBankAccountsWrapper() {
    try {
      const bankAccounts = await getBankAccounts();
      bankAccounts.length > 0 ? setHasBank(true) : setHasBank(false);
    } catch (error) {
      setHasBank(false);
    }
  }

  async function getPlaidLinkTokenWrapper() {
    try {
      const plaidToken = await getPlaidLink();
      setPlaidLinkToken(plaidToken.link_token);
    } catch (error) {
      setPlaidLinkToken('error');
    }
  }

  async function getCompanyWrapper() {
    try {
      const business = await getCompany();
      const user = await getUserAttributes();
      const subEmail = user.email.substring(0, user.email.lastIndexOf('@'));
      if (subEmail === business.name) {
        setBusiness({ ...business, name: null });
      } else setBusiness(business);
    } catch (error) {
      setBusiness({});
    }
  }

  async function getAmazonSellerAccountsWrapper() {
    try {
      const amzAccounts = await getAmazonSellerAccounts();
      setAmzAccounts(amzAccounts);
    } catch (error) {
      setAmzAccounts([]);
    }
  }

  async function getNeededDataFromServer() {
    setLoading(true);
    await Promise.all([
      getLinesInApplication(),
      getBankAccountsWrapper(),
      getPlaidLinkTokenWrapper(),
      getCompanyWrapper(),
      getAmazonSellerAccountsWrapper(),
    ]);
    dialogs.close('applicationSubmitted');
    setGotDataFromServer(true);
    setLoading(false);
  }

  useEffect(() => {
    getNeededDataFromServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {gotDataFromServer && (
        <React.Fragment>
          {!dialogs.applicationSubmitted && (
            <Container className={classes.root}>
              <Layout
                hasBank={hasBank}
                plaidLinkToken={plaidLinkToken}
                business={business}
                lines={lines}
                amzAccounts={amzAccounts}
                setHasBank={setHasBank}
                setBusiness={setBusiness}
                setLoading={setLoading}
              />
            </Container>
          )}
          {dialogs.applicationSubmitted && <Success />}
        </React.Fragment>
      )}

      {!loading && <TermOfUseAndPrivacyPolicy />}
    </React.Fragment>
  );
}
